import { faPhone, faVideo } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate } from 'react-router-dom'
import { useState, useEffect } from 'react'

import useAuth from '../../hooks/useAuth'
import moment from 'moment'

import EditAppointment from '../../components/EditAppointmentSlideout'
import NextAppointment from '../../components/NextAppointment'
import ActiveReferrals from '../../components/ActiveReferrals'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import MainTitle from '../../components/MainTitle'

const Referrals = () => {
  const { setShowLoader, auth } = useAuth()

  const navigate = useNavigate()
  const axios = useAxiosPrivate()

  const [latestReferral, setLatestReferral] = useState(null)
  const [open, setOpen] = useState(false)

  const [referrals, setReferrals] = useState([])

  useEffect(() => {
    fetchReferrals()
  }, [])

  const viewReferral = (referral) => {
    navigate(`/referral/${referral.booking_id}`, {
      state: {
        booking: referral.booking_id,
      },
    })
  }

  const fetchReferrals = async () => {
    setShowLoader(true)
    try {
      const response = await axios.get(`/bookings/user/${auth?.user?.id}/all`)
      if (response.data.error) {
        console.error(response.data.message)
        return
      }

      setReferrals(response.data.result)
    } catch (error) {
      console.error('Error fetching referrals:', error)
    } finally {
      setShowLoader(false)
    }
  }

  return (
    <section>
      {open && (
        <EditAppointment
          open={open}
          setOpen={setOpen}
          booking={latestReferral.booking_id}
        />
      )}
      <section className="pb-6">

        <MainTitle title="" />

        <div className="mb-16">
          <NextAppointment />
        </div>

        <MainTitle title="My Enquiries" />

        <div className="mb-12">
          <ActiveReferrals />
        </div>
        
        <MainTitle title="My Referrals" subtitle="See the previous referrals you have booked with School Wellbeing" />

        <div className="mt-2 mb-4">

          <div className="space-y-6 max-w-3xl">
            {referrals.map((referral, index) => {
              if (['In Progress', 'Upcoming'].includes(referral.status)) {
                return null
              }

              return (
                <div
                  className="cursor-pointer"
                  key={index}
                  onClick={(e) => {
                    viewReferral(referral)
                  }}
                >
                  <div className="flex justify-between items-center mb-1">
                    <div className="flex items-center gap-3">
                      <FontAwesomeIcon
                        icon={referral.type === 'Video' ? faVideo : faPhone}
                        className="text-lg text-[#BA95C4]"
                      />
                      <h3 className="font-medium">
                        GP {referral.type} Consultation
                      </h3>
                    </div>
                    <span
                      className={`text-xs font-semibold px-3 py-1 rounded-full ${referral.status === 'Booked'
                          ? 'bg-green-200 text-green-800'
                          : 'bg-orange-200 text-orange-800'
                        }`}
                    >
                      {referral.status}
                    </span>
                  </div>
                  <p className="text-sm text-gray-600">
                    {moment(referral.start_time).format('dddd Do MMMM YYYY')}{' '}
                    {moment(referral.start_time).format('hh:mm A')}
                  </p>
                  <hr className="mt-4 border-[#e8e0ed]" />
                </div>
              )
            })}
          </div>
        </div>
      </section>
    </section>
  )
}

export default Referrals
